import { LitEntity, html } from '../../utility/lit-entity';
import { BnModalMixin } from '../../common/bn-modal-mixin';
import '../../common/bn-action';
import '../../common/bn-flash';
import './combine-bins';

class CombineBinsModal extends BnModalMixin(LitEntity) {
  constructor() {
    super();
    this.id = 'combine-bins-modal';
  }

  static get properties() {
    return {
      actionHref: { type: String, attribute: false },
      binsHref: { type: String, attribute: false },
    };
  }

  renderContents() {
    return html`
      <style>
        bn-modal#combine-bins-modal {
          --modal-min-width: 80%;
          --modal-min-height: 90%;
        }
        organization-ancestors-bread-crumbs {
          display: inline;
        }
        .adding-into {
          margin-top: 0.75em;
          display: flex;
          margin-bottom: 1em;
          opacity: .7;
        }
        h3 {
          margin: 0;
        }
        .description {
          margin-bottom: .5em;
        }
      </style>

      <h3 slot="title">Create Tandem</h3>
      <bn-flash id="status"></bn-flash>

      <div class="description">
        Select two or more bins to mark them as being in tandem.
      </div>

      <div class="adding-into">
        Combine Bins from:&nbsp;
        <organization-ancestors-bread-crumbs .href="${this.href}" linkPath="" ancestorMinIndex="0">
        </organization-ancestors-bread-crumbs>
      </div>

      <combine-bins
        .href="${this.actionHref}"
        @error="${this._onError}"
      ></combine-bins>

      <lit-entity .href="${this.binsHref}" @update="${this._onBinsUpdate}"></lit-entity>
    `;
  }

  _onBinsUpdate(e) {
    const { entity } = e.detail;
    if (!entity) {
      return;
    }

    const action = entity.getActionByName('start-aggregate-bin') || {};
    this.actionHref = action.href;
  }

  _onError(e) {
    const { message } = e.error;
    const flash = this.renderRoot.querySelector('#status');

    flash.clear();
    flash.critical(html`
      Bin Creation Failed
      <br/>
      <code>${message}</code>
    `);
  }

  _entityChanged(entity) {
    super._entityChanged(entity);
    if (!this.entity) {
      return;
    }

    this.binsHref = this.getHref('https://api.binsentry.com/rel/v2/bins');
  }
}

window.customElements.define('combine-bins-modal', CombineBinsModal);
